import { Card, Col, Container, Form, Row } from "react-bootstrap";
import "./Tarjetax.css";

const CLASS_UI = {
  PADRE: { mod: "tx-padre", label: "Padre" },
  HIJO: { mod: "tx-hijo", label: "Hijo" },
  OTRO: { mod: "tx-otro", label: "Otro" },
};

const Tarjetax = ({ row, idx, clase, checked, onCheck, viewLine, viewMetada, viewFiles, viewImages }) => {
  const ui = CLASS_UI[clase] || CLASS_UI.OTRO;
  const esImagen =
    row.TYPEXXXX === "image/png" ||
    row.TYPEXXXX === "image/jpeg" ||
    row.TYPEXXXX === "image/jpg";
  const esInvalido = row.REGESTXX === "INVALIDO";

  return (
    <Card className={`shadow rounded p-3 tx-card ${ui.mod} ${esInvalido ? "tx-inv" : ""}`}>
      <span className={`tx-badge ${ui.mod}`}>{ui.label}</span>
      <Container fluid>
        <Row>
          <Col>
            {esImagen ? (
              <img
                variant="top"
                src={`${process.env.REACT_APP_GESTOR_WEB}/${row.imgfilex}`}
                width="25"
                height="35"
                alt="imagen-files"
              />
            ) : (
              <img
                variant="top"
                src={`${process.env.REACT_APP_GESTOR_WEB}/${row.imgfilex}`}
                width="50"
                alt="imagen-files"
              />
            )}
          </Col>
          <Col className="d-grid justify-content-end">
            <Form.Check
              value={`${row.IDARCHXX}`}
              onChange={(e) => onCheck(idx, e)}
              checked={!!checked}
              disabled={esInvalido}
            />
          </Col>
        </Row>
        <Row>
          <Card.Body>
            <Container>
              {esImagen ? (
                <Row>
                  <Col className="d-grid justify-content-center">
                    <img variant="top" src={`${row.IMGPREVX}`} alt="No se encontro Prev-Imagen" />
                  </Col>
                </Row>
              ) : (
                ""
              )}
              <Row>
                <Col className="col-12 text-doc p-0">
                  <strong>TIPO</strong> : {row.TIPODESX}
                </Col>
              </Row>
              {Object.keys(row.METADATX).map((item, key) => {
                if (key <= 3) {
                  let typeMet = "";
                  typeof row.METADATX[item] === "object" && row.METADATX[item] !== null
                    ? (typeMet = row.METADATX[item].join(", "))
                    : (typeMet = row.METADATX[item]);
                  typeMet = typeMet.length > 30 ? typeMet.substring(0, 30) + "..." : typeMet;
                  return (
                    <Row key={key}>
                      <Col className="col-12 text-doc p-0">
                        <strong>{item}</strong> : {typeMet}
                      </Col>
                    </Row>
                  );
                }
                return "";
              })}
              {row.METAEXCE &&
                row.METAEXCE.map((meta) => (
                  <Row key={meta.METDESXX}>
                    <Col className="col-12 text-doc p-0">
                      <strong>{meta.METDESXX}</strong> :{" "}
                      {Array.isArray(meta.DOCEVALX)
                        ? meta.DOCEVALX.slice(0, 2).join(", ") + (meta.DOCEVALX.length > 2 ? ", ..." : "")
                        : meta.DOCEVALX}
                    </Col>
                  </Row>
                ))}
              <Row>
                <Col className="col-12 text-doc p-0">
                  <strong>FECHA</strong> : {row.REGFECXX} / {row.REGHORXX}
                </Col>
              </Row>
            </Container>
          </Card.Body>
        </Row>
        <Row>
          <Col>
            <img
              onClick={() => viewLine(row)}
              src={`${process.env.REACT_APP_GESTOR_WEB}/images/icon-timeline.png`}
              height={30}
              alt="time line"
              style={{ cursor: "pointer" }}
            />
          </Col>
          <Col>
            <img
              onClick={() => viewMetada(row.METADATX, row.JSONMETX, row.METAEXCE)}
              variant="top"
              src={`${process.env.REACT_APP_GESTOR_WEB}/images/icon-info.png`}
              height={30}
              alt="info"
              style={{ cursor: "pointer" }}
            />
          </Col>
          <Col>
            <img
              onClick={() => (esImagen ? viewImages(row) : viewFiles(row))}
              variant="top"
              src={`${process.env.REACT_APP_GESTOR_WEB}/images/icon-view.png`}
              height={30}
              alt="view"
              style={{ cursor: "pointer" }}
            />
          </Col>
        </Row>
      </Container>
    </Card>
  );
};

export default Tarjetax;
